import { render, staticRenderFns } from "./Heading2Frequency.vue?vue&type=template&id=1fce732d&"
import script from "./Heading2Frequency.vue?vue&type=script&lang=js&"
export * from "./Heading2Frequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports